import { EventAction, GtmEventPartial } from "./trackGtmEvent";

const createClickEvent = (gtmEventPartial: GtmEventPartial) => ({
  eventAction: EventAction.click,
  ...gtmEventPartial,
});
const createImpressionEvent = (gtmEventPartial: GtmEventPartial) => ({
  eventAction: EventAction.impression,
  ...gtmEventPartial,
});

const TOP_NAV = {
  DROPDOWN_CLICK: createClickEvent({
    eventCategory: "dropdown",
  }),
  MORE_CLICK: createClickEvent({
    eventCategory: "top nav",
    eventLabel: "more categories",
  }),
  NAV_LINK_CLICK: createClickEvent({
    eventCategory: "top nav",
  }),
};

const PRODUCT = {
  CARD_CLICK: createClickEvent({
    eventCategory: "Product Card",
  }),
  CARD_IMPRESSION: createImpressionEvent({
    eventCategory: "Product Card",
  }),
  CAROUSEL_SEE_MORE_CLICK: createClickEvent({
    eventCategory: "carousel",
  }),
};

export { PRODUCT, TOP_NAV };
